export default __webpack_public_path__ + "static/media/bannerbackground.0f3b87c0.png";